import { OrderState } from './../enums/order-state.enum';
import { inject, Pipe, PipeTransform } from '@angular/core';
import { TranslocoService } from '@ngneat/transloco';
import { OrderStateData } from '../utils/order-state-util';

@Pipe({
    name: 'orderStateLabel',
    standalone: true
})
export class OrderStateLabelPipe implements PipeTransform {
    private readonly translocoService = inject(TranslocoService);

    transform(state: OrderState): unknown {
        return this.translocoService.translate(OrderStateData[state].label);
    }
}
